(() => {
  if (window.moxcardsMenuAnchorInstalled) return;
  window.moxcardsMenuAnchorInstalled = true;
  let scheduled = false;
  const initializedHeaders = new WeakSet();
  const position = () => {
    scheduled = false;
    const header = document.getElementById('header-component');
    if (!header) return;
    const desktop = matchMedia('(min-width: 750px)').matches && header.dataset.menuStyle !== 'drawer';
    const changes = [];
    header.querySelectorAll('.menu-list__list-item').forEach(item => {
      const submenu = item.querySelector(':scope > .menu-list__submenu');
      const list = submenu?.querySelector('.mox-compact-menu');
      const grid = list?.parentElement;
      const trigger = item.querySelector(':scope > .menu-list__trigger > .menu-list__link, :scope > a.menu-list__link');
      if (!list || !grid || !trigger) return;
      if (!desktop || item.getAttribute('slot') === 'overflow' || item.getAttribute('aria-hidden') === 'true') {
        if (list.dataset.moxAnchored) {
          changes.push(() => {
            list.style.removeProperty('margin-left');
            list.style.removeProperty('margin-right');
            delete list.dataset.moxAnchored;
          });
        }
        return;
      }
      if (!item.matches(':hover, :focus-within') && !item.querySelector('[aria-expanded="true"]')) return;
      const bounds = grid.getBoundingClientRect();
      const triggerBounds = trigger.getBoundingClientRect();
      const width = list.getBoundingClientRect().width;
      if (!bounds.width || !triggerBounds.width || !width) return;
      const desired = triggerBounds.left - bounds.left;
      const offset = Math.max(0, Math.min(desired, bounds.width - width));
      const margin = Math.round(offset) + 'px';
      changes.push(() => {
        if (list.style.getPropertyValue('margin-left') !== margin) list.style.setProperty('margin-left', margin, 'important');
        if (list.style.getPropertyValue('margin-right') !== '0px') list.style.setProperty('margin-right', '0px', 'important');
        if (list.dataset.moxAnchored !== 'true') list.dataset.moxAnchored = 'true';
      });
    });
    changes.forEach(apply => apply());
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(position);
  };
  const init = () => {
    const header = document.getElementById('header-component');
    if (!header) return;
    schedule();
    if (initializedHeaders.has(header)) return;
    initializedHeaders.add(header);
    const onEnter = event => {
      const item = event.target.closest?.('.menu-list__list-item');
      if (!item || item === event.relatedTarget?.closest?.('.menu-list__list-item')) return;
      schedule();
    };
    header.addEventListener('pointerover', onEnter, {passive:true});
    header.addEventListener('focusin', onEnter);

  };
  window.addEventListener('resize', schedule, {passive:true});
  if (document.fonts?.ready) document.fonts.ready.then(schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
